import { onPath } from '../utils/path';
import { selectMany, addClass, removeClass, toggleClass, whenOlarkExists, scrollToSmooth } from '../utils/dom-utils';


var visitorHasChatted = false;

var setupChatbotCTA = function(){
  window.__OlarkisAvailable =  false;

  whenOlarkExists(function(){
    olark('api.chat.onOperatorsAvailable', function() {
      window.__OlarkisAvailable = false; 
      // NOTE: switch this back to TRUE, when JSCLIENT can tell us if an operator (not bot) is available. 
      //A/B tests show talking to a human here increases conversation.
      
    });
    olark('api.chat.onOperatorsAway', function() {
      window.__OlarkisAvailable = false;
    });


    // Only fire this event when the operator actually talks.
    olark('api.chat.onMessageToOperator', function () {
      if(window.__OlarkisAvailable){
        if(!visitorHasChatted){
          window._vis_opt_queue = window._vis_opt_queue || [];
    	    window._vis_opt_queue.push(function() {window._vis_opt_goal_conversion(202);});
          window._vis_opt_queue.push(function() {window._vis_opt_goal_conversion(204);});
          window._vis_opt_queue.push(function() {window._vis_opt_goal_conversion(205);});
        }
        visitorHasChatted = true;
      }
    });



  });


  var handleClickonCTA = function(e, el) {
    var variant = el.dataset.variant;

    // NOTE: in 2023 we test starting a chat OR scrolling to box, starting a chat won by a significant margin.
    if(window.__OlarkisAvailable){
      olark('api.visitor.updateCustomFields', {
      	clickedCopilotChatCTA: true
      });

      if(variant == 'existing'){
        olark('api.chat.sendNotificationToOperator', {
          body: "Existing Customer wants to chat about Copilot"
        });
      }else{
        olark('api.chat.sendNotificationToOperator', {
          body: "New customer wants to chat about Copilot"
        });
      }

      olark('api.box.expand');

    }else{
        scrollToSmooth('call-form');
    }
    return false;
  }

  const olarkProCTA = selectMany('.olark-copilot-contact-cta');
  olarkProCTA.forEach(function (el, i) {
    el.href = "javascript:void(0)";
    el.addEventListener('click', function(e) { handleClickonCTA(e,el)});
  });


};


onPath('/chatbot-copilot', () => {
  whenOlarkExists(function() {
    olark.configure("locale.chatting_title", "Let's chat about Copilot");
  });

  setupChatbotCTA();
});

